import { BaseFetchOptions } from "../options";

export const baseWebFetchOptions: Partial<BaseFetchOptions> = {
  mode: "cors",
  // This is needed because otherwise server cookie that contains access token won't be passed to server requests
  credentials: "include",
  headers: {
    "content-type": "application/json",
  },
};
